import { useState, useEffect } from "react";
import { getApiUrl } from "../config/api";
import "../App.css";
import NotificationBar from "./components/NotificationBar.tsx";

function HomeScreen() {
    // State for header scroll effect
    const [isScrolled, setIsScrolled] = useState(false);
    
    // State for FAQ items
    const [activeFaqIndex, setActiveFaqIndex] = useState(null);

    // State for email input and options
    const [email, setEmail] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        address: ''
    });

    // State for notifications
    const [notification, setNotification] = useState(null);

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };
        
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle email submission
    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        const trimmedEmail = email.trim();

        if (!trimmedEmail) {
            setNotification({
                message: 'Please enter an email address',
                type: 'error'
            });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmedEmail)) {
            setNotification({
                message: 'Please enter a valid email address',
                type: 'error'
            });
            return;
        }

        setShowOptions(true);
    };

    // Handle option selection
    const handleOptionSelect = async (option) => {
        setSelectedOption(option);
        setShowModal(true);
    };

    // Modal component
    const Modal = ({ onClose, onSubmit }) => {
        const [localFormData, setLocalFormData] = useState({
            firstName: '',
            lastName: '',
            street: '',
            aptSuite: '',
            city: '',
            state: '',
            zipCode: ''
        });

        const handleLocalInputChange = (e) => {
            const { name, value } = e.target;
            setLocalFormData(prev => ({
                ...prev,
                [name]: value
            }));
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            onSubmit(e, localFormData);
        };

        return (
            <div className="modal-overlay">
                <div className="modal-content" style={{
                    backgroundColor: 'white',
                    padding: '2rem',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    maxWidth: '500px',
                    width: '90%',
                    margin: '0 auto',
                    position: 'relative'
                }}>
                    <button 
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            top: '1rem',
                            right: '1rem',
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#666',
                            padding: '0.5rem',
                            lineHeight: 1
                        }}
                    >
                        ×
                    </button>
                    <h2 style={{ 
                        marginBottom: '1.5rem',
                        textAlign: 'center',
                        color: '#333'
                    }}>
                        {selectedOption === 'Tahara' ? 'Join Waiting List' : 'Get Your Sample Story'}
                    </h2>
                    <form onSubmit={handleSubmit} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem'
                    }}>
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={localFormData.firstName}
                            onChange={handleLocalInputChange}
                            required
                            style={{ 
                                width: '100%',
                                padding: '0.75rem',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '1rem'
                            }}
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={localFormData.lastName}
                            onChange={handleLocalInputChange}
                            required
                            style={{ 
                                width: '100%',
                                padding: '0.75rem',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '1rem'
                            }}
                        />
                        {selectedOption !== 'Tahara' && (
                            <>
                                <input
                                    type="text"
                                    name="street"
                                    placeholder="Street Address"
                                    value={localFormData.street}
                                    onChange={handleLocalInputChange}
                                    required
                                    style={{ 
                                        width: '100%',
                                        padding: '0.75rem',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        fontSize: '1rem'
                                    }}
                                />
                                <div style={{ 
                                    display: 'flex', 
                                    gap: '1rem',
                                    flexDirection: window.innerWidth <= 768 ? 'column' : 'row'
                                }}>
                                    <input
                                        type="text"
                                        name="aptSuite"
                                        placeholder="Apt/Suite (optional)"
                                        value={localFormData.aptSuite}
                                        onChange={handleLocalInputChange}
                                        style={{ 
                                            width: '100%',
                                            padding: '0.75rem',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            fontSize: '1rem'
                                        }}
                                    />
                                    <input
                                        type="text"
                                        name="city"
                                        placeholder="City"
                                        value={localFormData.city}
                                        onChange={handleLocalInputChange}
                                        required
                                        style={{ 
                                            width: '100%',
                                            padding: '0.75rem',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </div>
                                <div style={{ 
                                    display: 'flex', 
                                    gap: '1rem',
                                    flexDirection: window.innerWidth <= 768 ? 'column' : 'row'
                                }}>
                                    <input
                                        type="text"
                                        name="state"
                                        placeholder="State"
                                        value={localFormData.state}
                                        onChange={handleLocalInputChange}
                                        required
                                        style={{ 
                                            width: '100%',
                                            padding: '0.75rem',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            fontSize: '1rem'
                                        }}
                                    />
                                    <input
                                        type="text"
                                        name="zipCode"
                                        placeholder="ZIP Code"
                                        value={localFormData.zipCode}
                                        onChange={handleLocalInputChange}
                                        required
                                        style={{ 
                                            width: '100%',
                                            padding: '0.75rem',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </div>
                            </>
                        )}
                        <button type="submit" className="btn-primary" style={{ 
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0.75rem',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '1rem',
                            cursor: 'pointer'
                        }}>
                            {selectedOption === 'Tahara' ? 'Join Waiting List' : 'Submit'}
                        </button>
                    </form>
                </div>
            </div>
        );
    };

    // Handle full form submission
    const handleFullFormSubmit = async (e, localFormData) => {
        e.preventDefault();
        try {
            const apiBaseUrl = getApiUrl();
            const requestBody = {
                email,
                type: selectedOption,
                firstName: localFormData.firstName,
                lastName: localFormData.lastName
            };

            // Only add address fields if not Tahara
            if (selectedOption !== 'Tahara') {
                Object.assign(requestBody, {
                    street: localFormData.street,
                    aptSuite: localFormData.aptSuite,
                    city: localFormData.city,
                    state: localFormData.state,
                    zipCode: localFormData.zipCode
                });
            }

            const response = await fetch(`${apiBaseUrl}/v1/api/email/submit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                setEmail('');
                setShowModal(false);
                setShowOptions(false);
                setNotification({
                    message: selectedOption === 'Tahara' 
                        ? 'Thank you for joining the waiting list!' 
                        : 'Thank you for signing up!',
                    type: 'success'
                });
            } else {
                throw new Error('Failed to submit form');
            }
        } catch (error) {
            console.error('Error:', error);
            setNotification({
                message: 'Failed to submit. Please try again.',
                type: 'error'
            });
        }
    };

    return (
        <div className="App">
            {/* Header Section */}
            <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
                <nav className="navbar">
                    <div className="logo">
                        <span>[ Yellow ]</span>
                    </div>
                </nav>
            </header>

            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1>What's your favorite book to watch?</h1>
                    {!showOptions ? (
                        <form onSubmit={handleEmailSubmit} className="email-signup">
                            <input
                                type="email"
                                placeholder="Email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="btn-primary">
                                Sign Up
                            </button>
                        </form>
                    ) : (
                        <div className="signup-container" style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '1rem', 
                            width: '100%', 
                            maxWidth: '300px',
                            margin: '0 auto',
                            alignItems: 'center'
                        }}>
                            <button 
                                className="btn-primary"
                                onClick={() => handleOptionSelect('Tahara')}
                                style={{ width: '100%', textAlign: 'center' }}
                            >
                                Join Waiting List for Tahara
                            </button>
                            {/* <button 
                                className="btn-primary"
                                onClick={() => handleOptionSelect('Susanna')}
                                style={{ width: '100%', textAlign: 'center' }}
                            >
                                Get our Sample Story
                            </button>
                            <button 
                                className="btn-primary"
                                onClick={() => handleOptionSelect('Both')}
                                style={{ width: '100%', textAlign: 'center' }}
                            >
                                Both
                            </button> */}
                        </div>
                    )}
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq">
                <div className="faq-container">
                    <div className="faq-content">
                        <h2 style={{ lineHeight: 1 }}>Frequently Asked Questions</h2>
                        <div className="faq-list">
                            {[
                                {
                                    question: "What is Yellow?",
                                    answer: "YELLOW is a multimedia platform that combines literature and film within a single book, using both traditional film and AI-generated film. Readers can effortlessly switch between reading and watching through QR codes that unlock film chapters, creating an immersive storytelling experience."
                                },
                                {
                                    question: "How does it work?",
                                    answer: "Each YELLOW book features QR codes that, when scanned, unlock professionally produced film segments that correspond to key moments in the story. These film chapters bring the story to life while maintaining the depth of a traditional book."
                                },
                                {
                                    question: "What can I read and watch now?",
                                    answer: <>
                                        <p><i>The Tahara Project</i> is the first release under YELLOW and the first-ever TV series in a book. This new age drama with twist and turns is a groundbreaking hybrid of literature and film designed to showcase the power of our book-to-film format.</p>
                                        <p>Sign up and join 5,000 + early readers ready for the first-ever Tv series in a book set to release this fall.</p>
                                    </>
                                }
                            ].map((faq, index) => (
                                <div 
                                    key={index} 
                                    className={`faq-item ${activeFaqIndex === index ? 'active' : ''}`}
                                >
                                    <button 
                                        className="faq-question"
                                        onClick={() => setActiveFaqIndex(activeFaqIndex === index ? null : index)}
                                    >
                                        {faq.question} <i className="fas fa-plus"></i>
                                    </button>
                                    <div className="faq-answer">
                                        {typeof faq.answer === 'string' ? <p>{faq.answer}</p> : faq.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="faq-image">
                        <img src="/images/lady_with_book.png" alt="Lady with Book" />
                    </div>
                </div>
            </section>

            {/* Email Section */}
            <section id="email-section" className="email-section">
                <div className="email-container">
                    <div className="email-content">
                        <p>Try our sample story, <i>Susanna Maybe</i>?</p>
                        {!showOptions ? (
                            <form onSubmit={handleEmailSubmit} className="email-signup">
                                <input
                                    type="email"
                                    placeholder="Email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <button type="submit" className="btn-primary">
                                    Sign Up
                                </button>
                            </form>
                        ) : (
                            <div className="signup-container" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', maxWidth: '300px' }}>
                                <button 
                                    className="btn-primary"
                                    onClick={() => handleOptionSelect('Tahara')}
                                >
                                    Join Waiting List for Tahara
                                </button>
                                <button 
                                    className="btn-primary"
                                    onClick={() => handleOptionSelect('Susanna')}
                                >
                                    Get our Sample Story
                                </button>
                                <button 
                                    className="btn-primary"
                                    onClick={() => handleOptionSelect('Both')}
                                >
                                    Both
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="email-image">
                        <img src="/images/overlayed_image_2.png" alt="" />
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-company">
                        <span>Yellow Multimedia Corporation v2</span>
                    </div>
                    <div className="footer-links">
                        <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=6ff7ecb7-7af1-4292-9a62-b5424a317db3">Terms and Conditions</a>
                        <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=7e5b5bf2-c604-4638-954f-fc5887e5665b">Privacy Policy</a>
                        <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=85e9cfe5-899f-4c70-b0da-671607d8db63">Cookie Policy</a>
                    </div>
                </div>
            </footer>

            {/* Modal */}
            {showModal && (
                <Modal
                    onClose={() => {
                        setShowModal(false);
                    }}
                    onSubmit={handleFullFormSubmit}
                />
            )}

            {/* Add NotificationBar */}
            {notification && (
                <NotificationBar
                    message={notification.message}
                    type={notification.type}
                    onClose={() => setNotification(null)}
                />
            )}
        </div>
    );
}

export default HomeScreen;